function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "filled_outline",
  "data-name": "filled outline"
}, /*#__PURE__*/React.createElement("path", {
  d: "m160 264h-16a8 8 0 0 1 0-16h16a8 8 0 0 1 0 16z",
  fill: "#a8a8a8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m144 296a8 8 0 0 1 -8-8v-48a8 8 0 0 0 -16 0v16a8 8 0 0 1 -16 0v-16a24 24 0 0 1 48 0v48a8 8 0 0 1 -8 8z",
  fill: "#cbcbcb"
}), /*#__PURE__*/React.createElement("path", {
  d: "m272 248h-24a8 8 0 0 1 0-16h24a8 8 0 0 1 0 16z",
  fill: "#cbcbcb"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28 464h328a4 4 0 0 0 4-4v-168a4 4 0 0 0 -4-4h-28v8h-128v-8h-172a4 4 0 0 0 -4 4v168a4 4 0 0 0 4 4z",
  fill: "#683b0d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m200 288h128v48h-128z",
  fill: "#cbcbcb"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#6ee7f5",
  height: 240,
  rx: 16,
  width: 128,
  x: 360,
  y: 224
}), /*#__PURE__*/React.createElement("g", {
  fill: "#2cbff4"
}, /*#__PURE__*/React.createElement("path", {
  d: "m360 304h128v8h-128z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392 280a8 8 0 0 1 -8-8v-16a8 8 0 0 1 16 0v16a8 8 0 0 1 -8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392 360a8 8 0 0 1 -8-8v-16a8 8 0 0 1 16 0v16a8 8 0 0 1 -8 8z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m200 336h128v96h-128z",
  fill: "#eaeae8",
  transform: "matrix(-1 0 0 -1 528 768)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m280 376h-32a8 8 0 0 1 0-16h32a8 8 0 0 1 0 16z",
  fill: "#2cbff4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m56 384h112v48h-112z",
  fill: "#533222",
  transform: "matrix(-1 0 0 -1 224 816)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m56 320h112v32h-112z",
  fill: "#533222",
  transform: "matrix(-1 0 0 -1 224 672)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m280 264h48v24h-48z",
  fill: "#2cbff4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m200 264h48v24h-48z",
  fill: "#2cbff4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m200 232h48a0 0 0 0 1 0 0v15.984a16.016 16.016 0 0 1 -16.016 16.016h-15.968a16.016 16.016 0 0 1 -16.016-16.016v-15.984a0 0 0 0 1 0 0z",
  fill: "#d32b39"
}), /*#__PURE__*/React.createElement("path", {
  d: "m296 48h192v80h-192z",
  fill: "#683b0d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m320 104a8 8 0 0 1 -8-8v-16a8 8 0 0 1 16 0v16a8 8 0 0 1 -8 8z",
  fill: "#533222"
}), /*#__PURE__*/React.createElement("path", {
  d: "m416 104a8 8 0 0 1 -8-8v-16a8 8 0 0 1 16 0v16a8 8 0 0 1 -8 8z",
  fill: "#533222"
}), /*#__PURE__*/React.createElement("path", {
  d: "m296 128h192v24h-192z",
  fill: "#cbcbcb"
}), /*#__PURE__*/React.createElement("path", {
  d: "m104 136a8 8 0 0 1 -8-8v-48a8 8 0 0 1 16 0v48a8 8 0 0 1 -8 8z",
  fill: "#6ee7f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m144 176h-80l24-48h32z",
  fill: "#fbb540"
}), /*#__PURE__*/React.createElement("path", {
  d: "m224 136a8 8 0 0 1 -8-8v-48a8 8 0 0 1 16 0v48a8 8 0 0 1 -8 8z",
  fill: "#6ee7f5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m264 176h-80l24-48h32z",
  fill: "#fbb540"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24 48h272v32h-272z",
  fill: "#cbcbcb"
}), /*#__PURE__*/React.createElement("path", {
  d: "m48 248a16 16 0 0 1 16 16v24a0 0 0 0 1 0 0h-32a0 0 0 0 1 0 0v-24a16 16 0 0 1 16-16z",
  fill: "#6ee7f5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 232,
  cy: 312,
  fill: "#eaeae8",
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 264,
  cy: 312,
  fill: "#eaeae8",
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 296,
  cy: 312,
  fill: "#eaeae8",
  r: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "m32 280h32v8h-32z",
  fill: "#2cbff4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m280 48h16v32h-16z",
  fill: "#a8a8a8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m376 48h16v80h-16z",
  fill: "#533222"
}), /*#__PURE__*/React.createElement("path", {
  d: "m200 296h-176v-4a4 4 0 0 1 4-4h172z",
  fill: "#533222"
}), /*#__PURE__*/React.createElement("path", {
  d: "m328 288h28a4 4 0 0 1 4 4v4a0 0 0 0 1 0 0h-32a0 0 0 0 1 0 0v-8a0 0 0 0 1 0 0z",
  fill: "#533222"
}), /*#__PURE__*/React.createElement("path", {
  d: "m216 80h16v16h-16z",
  fill: "#2cbff4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m96 80h16v16h-16z",
  fill: "#2cbff4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m200 336h128v8h-128z",
  fill: "#a8a8a8"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392 280a8 8 0 0 0 8-8v-16a8 8 0 0 0 -16 0v16a8 8 0 0 0 8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392 328a8 8 0 0 0 -8 8v16a8 8 0 0 0 16 0v-16a8 8 0 0 0 -8-8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m365.659 469.655a23.858 23.858 0 0 0 10.341 2.345h96a24.027 24.027 0 0 0 24-24v-208a24.027 24.027 0 0 0 -24-24h-96a24.027 24.027 0 0 0 -24 24v40h-16v-16a8 8 0 0 0 -8-8h-48a8 8 0 0 0 -8 8v16h-16v-16a7.975 7.975 0 0 0 -2.35-5.663 23.875 23.875 0 0 0 2.35-10.337h16a8 8 0 0 0 0-16h-16a8 8 0 0 0 -8-8h-48a8 8 0 0 0 -8 8v15.983a23.872 23.872 0 0 0 2.35 10.354 7.975 7.975 0 0 0 -2.35 5.663v16h-40v-16h8a8 8 0 0 0 0-16h-8v-8a24 24 0 0 0 -48 0v16a8 8 0 0 0 16 0v-16a8 8 0 0 1 16 0v40h-64v-16a24 24 0 0 0 -48 0v16a8 8 0 0 0 -8 8v176a8 8 0 0 0 8 8h336a7.975 7.975 0 0 0 5.659-2.345zm106.341-13.655h-96a8.009 8.009 0 0 1 -8-8v-136h112v136a8.009 8.009 0 0 1 -8 8zm-104-216a8.009 8.009 0 0 1 8-8h96a8.009 8.009 0 0 1 8 8v56h-112zm-48 56v32h-112v-32zm-112 48h112v80h-112zm80-72h32v8h-32zm-80 8v-8h32v8zm0-40h32v7.983a8.026 8.026 0 0 1 -8.017 8.017h-15.966a8.026 8.026 0 0 1 -8.017-8.017zm-168 24a8 8 0 0 1 16 0v16h-16zm312 192h-320v-160h160v136a8 8 0 0 0 8 8h128a8 8 0 0 0 8-8v-136h16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m280 360h-32a8 8 0 0 0 0 16h32a8 8 0 0 0 0-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m168 376h-112a8 8 0 0 0 -8 8v48a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-48a8 8 0 0 0 -8-8zm-8 48h-96v-32h96z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m168 312h-112a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8h112a8 8 0 0 0 8-8v-32a8 8 0 0 0 -8-8zm-8 32h-96v-16h96z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m320 104a8 8 0 0 0 8-8v-16a8 8 0 0 0 -16 0v16a8 8 0 0 0 8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m416 104a8 8 0 0 0 8-8v-16a8 8 0 0 0 -16 0v16a8 8 0 0 0 8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24 88h72v32h-8a8 8 0 0 0 -7.155 4.422l-24 48a8 8 0 0 0 7.155 11.578h80a8 8 0 0 0 7.155-11.578l-24-48a8 8 0 0 0 -7.155-4.422h-8v-32h104v32h-8a8 8 0 0 0 -7.155 4.422l-24 48a8 8 0 0 0 7.155 11.578h80a8 8 0 0 0 7.155-11.578l-24-48a8 8 0 0 0 -7.155-4.422h-8v-32h56v64a8 8 0 0 0 8 8h192a8 8 0 0 0 8-8v-104a8 8 0 0 0 -8-8h-464a8 8 0 0 0 -8 8v32a8 8 0 0 0 8 8zm107.056 80h-54.112l16-32h22.112zm120 0h-54.112l16-32h22.112zm52.944-112h72v64h-72zm176 88h-176v-8h176zm0-24h-88v-64h88zm-448-64h256v16h-256z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 232,
  cy: 312,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 264,
  cy: 312,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 296,
  cy: 312,
  r: 8
}));

var SvgKitchen = function SvgKitchen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKitchen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kitchen.f506b45d.svg";
export { ForwardRef as ReactComponent };